/** @format */

function hasMedia(name = null) {
  return this.getMedia(name)?.length > 0 || false;
}
export { hasMedia };
